import Vue from 'vue';
import keys from 'lodash/keys';
import { pascalToSnake } from '@@/helpers';
import * as Components from './list';

// Some components aren't using the same name as the module name, for these we
// declare an object with the map of module names - component name.
const nameReplace = {
  AppField: 'foo-field',
  Task: 'Task',
  Party: 'Party',
  Contact: 'Contact',
  Group: 'Group',
  GroupParty: 'GroupParty',
  GroupTask: 'GroupTask',
  Trigger: 'Trigger'
};

// No need to repeat the sames lines from importing, only iterate through all
// the module names and convert to snake case for declaration.
keys(Components).map(k => Vue.component(
  nameReplace[k] || pascalToSnake(k), Components[k]
));
